import { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { IControl } from 'mapbox-gl';

import { ControlPosition } from '../types';
import { useControl } from './useControl';

class CustomControl implements IControl {
  container: HTMLElement;

  constructor() {
    this.container = document.createElement('div');
    this.container.classList.add('mapboxgl-ctrl');
    this.container.classList.add('mapboxgl-ctrl-group');
  }

  getContainer() {
    return this.container;
  }

  onAdd() {
    return this.container;
  }

  onRemove() {
    this.container.remove();
  }
}

interface MapboxControlProps {
  children: ReactNode;
  position: ControlPosition;
}

export const MapboxControl = ({ children, position }: MapboxControlProps) => {
  const ctrl = useControl({
    control: new CustomControl(),
    position
  });

  return createPortal(children, ctrl.getContainer());
};
